import React, { useEffect } from 'react';
import './cash.css';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import CashFrom from "../../components/CashForm/CashForm";
import { contextAction, setCashFormAction } from "../../redux/rootReducer";
import { CASH_FORM_INITIAL } from "../../redux/initialStateConstant";
import { getCashThunk } from "../../redux/thunks/getCashThunk";
import ContextMenu from "../../components/ContextMenu/ContextMenu";
import { getCashByIdThunk } from "../../redux/thunks/getCashByIdThunk";
import { removeCashThunk } from "../../redux/thunks/removeCashThunk";
import CashHeader from "../../components/PagesHeaders/CashHeader/CashHeader";

const Cash = () => {
    const dispatch = useDispatch();
    const cash = useSelector(state => state.cash);
    const context = useSelector(state => state.context);
    const payment_methods = useSelector(state => state.payment_methods);

    const menu = [
        {
            id: '1',
            caption: 'Редактировать запись',
            handler: () => {
                dispatch(getCashByIdThunk({
                    id: cash.cash_list.find(el => el.id === context).id
                }));
                dispatch(contextAction(false));
            }
        },
        {
            id: '2',
            caption: 'Удалить платёж',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить запись?')) {
                    dispatch(removeCashThunk({
                        id: cash.cash_list.find(el => el.id === context).id
                    }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    useEffect(() => {
        dispatch(getCashThunk({
            payment_method: cash.payment_method.id || payment_methods[0]?.id,
            date_from: cash.date_from,
            date_to: cash.date_to
        }));
    }, []);

    return (
        <>
            <CashFrom/>
            <Header component={ <CashHeader/> }/>
            <div className="page">
                <div className="page__content">
                    <div className="page__header">
                        <div className="table__header">
                            <div className="table__caption">Операции</div>
                        </div>
                        <div className="page__buttons">
                            <div className="page__button button"
                                 onClick={ () => {
                                     dispatch(setCashFormAction({
                                         ...CASH_FORM_INITIAL,
                                         open: true,
                                         date: new Date().toLocaleDateString('fr-CA'),
                                         type: 'deposit'
                                     }));
                                 } }
                            >Внести</div>
                            <div className="page__button button"
                                 onClick={ () => {
                                     dispatch(setCashFormAction({
                                         ...CASH_FORM_INITIAL,
                                         open: true,
                                         date: new Date().toLocaleDateString('fr-CA'),
                                         type: 'withdrawal'
                                     }));
                                 } }
                            >Вывести</div>
                        </div>
                    </div>

                    <div className="table">
                        <div className="table__row table__row--header table__row--cash">
                            <div className="table__cell">Дата</div>
                            <div className="table__cell">Сумма</div>
                            <div className="table__cell">Описание</div>
                            <div className="table__cell"/>
                        </div>

                        {
                            cash.cash_list.map(elem => {
                                return (
                                    <div className="table__row table__row--cash" key={ elem.id }>
                                        <ContextMenu data={{
                                            open: elem.id === context,
                                            style: { right: 28 },
                                            menu
                                        }}/>
                                        <div className="table__cell">{ elem.date }</div>
                                        <div className="table__cell" style={ elem.type === 'deposit' ? { color: '#07a23b' } : elem.type === 'withdrawal' ? { color: '#ca302a' } : '' }>{ elem.sum }</div>
                                        <div className="table__cell">{ elem.description }</div>
                                        <i className="menu__button" onClick={ event => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            dispatch(contextAction(elem.id));
                                        } }/>
                                    </div>
                                );
                            })
                        }


                        <div className="table__row table__row--header table__row--cash">
                            <div className="table__cell">Итого</div>
                            <div className="table__cell">{ cash.payment_sum }</div>
                            <div className="table__cell"/>
                        </div>
                    </div>

                    <div className="page__header" style={{ marginTop: '48px' }}>
                        <div className="table__header">
                            <div className="table__caption">Касса</div>
                        </div>
                    </div>
                    <div className="table">
                        <div className="table__row table__row--header table__row--cash-total">
                            <div className="table__cell">Период</div>
                            <div className="table__cell">Начало периода</div>
                            <div className="table__cell">Конец периода</div>
                        </div>
                        <div className="table__row table__row--cash-total">
                            <div className="table__cell">{ cash.period }</div>
                            <div className="table__cell">{ cash.cash_before }</div>
                            <div className="table__cell">{ cash.cash_after }</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Cash;